import { IFertiliserProduct } from "./models/omnia"
import { IFertiliserStock, IManureStock, ISeedStock, ITypedStock } from "./models/stock"
import { IOmniaService } from "./types"

export const manureStockTotalFields: string[] = ["N", "P2O5", "K2O", "SO3", "MgO"]

export const manureStockAnalysisFields: string[] = ["NNvzAvailable", "DryMatter", "N", "NAmmonium", "NNitrate", "NUricAcid", "P2O5", "P2O5Available", "K2O", "K2OAvailable", "SO3", "MgO"]

export interface SharedStocksService extends IOmniaService {

    readonly ready: boolean
    refresh(): ng.IPromise<any>
    ensureInit(): ng.IPromise<any>

    getSeedStocks(): ISeedStock[]
    getFertiliserStocks(): IFertiliserStock[]
    getFertiliserProducts(): IFertiliserProduct[]

    getManureStocks(): IManureStock[]
    editManureStock(stock: IManureStock): ng.IPromise<any>

    deleteStock(stock: ITypedStock): ng.IPromise<void>

    editFertiliserStock(stock: IFertiliserStock): ng.IPromise<any>
    editManureStock(stock: IManureStock): ng.IPromise<any>

    deleteStock(stock: ITypedStock): ng.IPromise<void>

}
